<template>
    <div class="card border-0 bg-dark text-white mb-3">
        <!-- begin card-body -->
        <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
                <b>TOP PRODUCTS BY UNITS SOLD (YEAR TO DATE)</b>
                <span class="ml-2">
                    <i class="fa fa-info-circle" id="total-units-sold"  data-title="Year to Date of products with units sold" data-placement="top" data-content=""></i>
                    <b-popover
                    target="total-units-sold"
                    title="Top Products By Units Sold"
                    triggers="hover focus"
                    placement="top"
                    content="This year's Sales According to Unit Sold ."
                    ></b-popover>
                </span>
            </div>
            <!-- end title -->
            <!-- begin product -->
            <div class="d-flex align-items-center m-b-15" v-for="(data, index) in datas">
                <div class="widget-img rounded-lg width-30 m-r-10 bg-white p-3">
                    <div class="h-100 w-200" :style="{background: 'url(' + require('@/assets/img/vehicle/' + data.imageName + '.png') + ')center no-repeat' , backgroundSize: 'auto 100%'}"></div>
                </div>
                <div class="text-truncate width-100">
                    <div>{{data.name}}</div>
                </div>
                <div class="ml-auto text-right" :class="data.colorText">

                    <i class="fa fa-caret-up"></i> <span class="count">{{data.percentageTrend}}</span>%
                </div>
                <div class="ml-auto text-center">
                    <div class="f-s-13"><span class="count">{{data.sold}}</span></div>
                    <div class="text-grey f-s-10">sold</div>
                </div>
                <div class="ml-auto text-center">
                    <LineChart :vehicleRef="data.ref"></LineChart>
                </div>
            </div>
            <!-- end product -->
            
        </div>
        <!-- end card-body -->
    </div>
</template>

<script>
import $ from 'jquery';
import LineChart from './Charts/LineChart';

$('.count').each(function () {
    $(this).prop('Counter',0).animate({
        Counter: $(this).text()
    }, {
        duration: 2500,
        easing: 'swing',
        step: function (now) {
            $(this).text(Math.round(now * 100) / 100);
        }
    });
});




export default {
    components : {
        LineChart
    },
    data(){
        return{
            datas : [],
            dataReady : false
        }
    },
    async mounted(){
        await this.loadVehicles();
    },
    methods : {
        loadVehicles(){
            var vehicleTypes = ["Ayla" , "Granmax" , "Himax" , "Luxio" , "Sigra" , "Sirion" , "Xenia" , 'Granmax-MB'];
            for(var i = 0 ; i < vehicleTypes.length ; i++){
                var obj = {
                    name : vehicleTypes[i],
                    imageName : vehicleTypes[i].toLowerCase(),
                    colorText : '',
                    chart : null,
                    percentageTrend :  Math.round(Math.random() * 10000) / 100 ,
                    sold : Math.round(Math.random() * 100),
                    ref : vehicleTypes[i]
                }
                if(obj.chartpercentageTrend > 80){
                    obj.colorText = 'text-green'
                }
                else if(obj.percentageTrend > 40){
                    obj.colorText = 'text-yellow'
                }
                else
                    obj.colorText = 'text-red'
            
                this.datas.push(obj);
            }
            // this.dataReady = true;
            
        },
        
    }
}
</script>